import React from 'react';
import Header from './components/Header/header';
import AppBody from './components/AppBody/AppBody';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <React.Fragment>
      <Header />
      <AppBody />
      <Footer />
    </React.Fragment>
  );
}

export default App;
